import { Component, Inject, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@app/services/auth.service';
import { UserService } from '@app/services/user.service';
import { StationService } from '@app/services/station.service';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SearchService } from '@app/services/search.service';
import { CommonModule } from '@angular/common';
import { FeedbackService } from '@app/services/feedback.service';

@Component({
  selector: 'app-add-review-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDividerModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
  ],
  templateUrl: './add-review-dialog.component.html',
  styleUrl: './add-review-dialog.component.scss'
})
export class AddReviewDialogComponent {
  dialogRef = inject(MatDialogRef<AddReviewDialogComponent>);

  state = signal<'initial' | 'loading' | 'success' | 'error'>('initial');

  private _formBuilder = inject(FormBuilder);
  formGroup = this._formBuilder.group({
    title: ['', Validators.required],
    description: ['', Validators.required],
  });
  ratings = [1, 2, 3, 4, 5];
  ratingScore = 0;

  constructor(
    private authService: AuthService,
    private feedbackService: FeedbackService,
    @Inject(MAT_DIALOG_DATA) public data: { stationId: number },
  ) {}

  close() {
    this.dialogRef.close();
  }

  submitForm() {
    if (!this.formGroup.valid) return;

    this.state.set('loading');
    this.feedbackService.addStationReview({
      stationId: this.data.stationId,
      userId: this.authService.userSignal().uid,
      name: this.authService.userSignal().displayName,
      title: this.formGroup.value.title,
      ratingScore: this.ratingScore,
      description: this.formGroup.value.description,
    }).subscribe({
      next: () => {
        this.resetFormState();
        this.state.set('success');
        this.dialogRef.close(true);
      },
      error: () => {
        this.state.set('error');
      },
    });
  }

  resetFormState() {
    this.formGroup.reset();
    Object.keys(this.formGroup.controls).forEach(key => {
      const control = this.formGroup.get(key);
      control?.markAsPristine();
      control?.markAsUntouched();
      control?.setErrors(null);
    });
  }
}
